import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/ShopifyIntegration/ShopifyConnect';

const ShopifyConnect = () => ((orgContainer(InnerComponent)));
export default ShopifyConnect;
